import React, { memo, useRef, useState } from 'react';

// Classname
import clsx from 'clsx';

// Link
import { Link } from 'react-router-dom';

// Lib
import { truncate } from 'lib/helpers';
import { useWindowSize } from 'lib/hooks';

// components
import Tooltip from './Tooltip';
import NoData from 'components/NoData';

// Type
import { TAbcWords } from '../type';

// Interface
interface IList {
	input?: string;
	className?: string;
	data?: TAbcWords[] | [];
}

export const List: React.FC<IList> = (props) => {
	const { input, data = [], className = '' } = props;

	const regex = new RegExp(`(${input})`, 'gi');
	const elementRefs = useRef<(HTMLParagraphElement | null)[]>([]);
	const elementRefsName = useRef<(HTMLParagraphElement | null)[]>([]);

	const [currentName, setCurrentName] = useState<string>('');
	const [currentIndex, setCurrentIndex] = useState<number>(-1);

	const { width } = useWindowSize();
	const isMobile = width < 1024;

	const cnWrapper = clsx(
		'all-drugs-vocabulary__list full-width flex flex-wrap flex-ai-start',
		className ? className : ''
	);

	const onMouseLeaveItem = () => {
		setCurrentIndex(-1);
	};

	const onMouseEnterItem = (key: string, index: number, name: 'name' | 'synonyms') => () => {
		setCurrentIndex(index);
		setCurrentName(name);
	};

	const getList = (data: TAbcWords[]) => {
		return data.length ? data.map((item: TAbcWords, i: number) => {
			const { drug, synonyms, impuritiesCount } = item;

			const key = `${item.drug}__${i}`;
			const link = `/impurities/${item?.ebcId}`;

			const clearedSynonyms = synonyms?.filter(
				(item: string) => item.toLowerCase() !== drug?.toLowerCase()
			);
			const sortedSynonyms = clearedSynonyms?.length
				? clearedSynonyms.concat()?.sort(
					(a, b) => a.length - b.length
				)
				: [];
			const synonymsJoined = sortedSynonyms?.join(' | ');
			const synonymsTruncated = truncate(synonymsJoined || '', 35);
			const drugNameTruncated = truncate(drug || '', 35);

			const template = '<span style="background: yellow; color: black">$1</span>';

			const synonymsFinallyTruncated = synonymsTruncated
				? synonymsTruncated.replace(regex, template)
				: '';

			const synonymsJoinedFinally = synonymsJoined
				? synonymsJoined.replace(regex, template)
				: '';

			const isSynonyms = currentName === 'synonyms';
			const tooltipValue = isSynonyms ? synonymsJoinedFinally : drug || '';
			const parentRef = isSynonyms ? elementRefs.current[currentIndex] : elementRefsName.current[currentIndex];

			return <Link
				key={key}
				to={link}
				id={i === 0 ? "all-drugs-vocabulary-list-item" : ''}
				state={{ findElement: input, drug: item?.drug || '' }}
				className="all-drugs-vocabulary__list-item flex flex-ai-start flex-jc-between flex-direction-column"
			>
				<div className="all-drugs-vocabulary__list-item-wrapper flex flex-ai-center flex-jc-between full-width">
					<p
						data-key={key}
						onMouseLeave={onMouseLeaveItem}
						className="all-drugs-vocabulary__list-name mb5"
						onMouseEnter={onMouseEnterItem(key, i, 'name')}
						ref={(el) => (elementRefsName.current[i] = el)}
						dangerouslySetInnerHTML={{ __html: drugNameTruncated || '' }}
					/>
					<p
						id={i === 1 ? 'all-drugs-vocabulary-item' : ''}
						className="all-drugs-vocabulary__item-label mb5 flex"
					>
						Impurities {impuritiesCount}
					</p>
				</div>
				<div className="full-width">
					<p
						data-key={key}
						onMouseLeave={onMouseLeaveItem}
						className="all-drugs-vocabulary__synonyms"
						ref={(el) => (elementRefs.current[i] = el)}
						onMouseEnter={onMouseEnterItem(key, i, 'synonyms')}
						dangerouslySetInnerHTML={{ __html: synonymsFinallyTruncated }}
					/>
					{!isMobile && currentIndex === i &&
						<Tooltip synonyms={tooltipValue} parentRef={parentRef} />
					}
				</div>
			</Link>;
		}) : <NoData text="No data available" />;
	};

	return (
		<div className={cnWrapper}>
			{getList(data)}
		</div>
	);
};

export default memo(List);
